<!--
 * @Description: 网盘管理-学校网盘 详细信息
 * @Author: PF
 * @Date: 2024-06-04 14:43:47
 * @LastEditors: PF
 * @LastEditTime: 2024-06-07 10:38:32
-->
<template>
  <div>
    <el-dialog class="w500 h400" :model-value="openDeatil" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">详细信息</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDeatil', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="detailBox">
        <div class="detailBox-top">
          <div class="wjIconBox">
            <el-image style="width: 100%; height: 100%" :src="'/wenjiantubiao/'+ruleForm.gs+'.png'" fit="contain">
              <template #error>
                <div class="image-slot">
                  <el-image style="width: 100%; height: 100%" :src="'/wenjiantubiao/moren.png'" fit="contain" />
                </div>
              </template>
            </el-image>
          </div>
          <div class="wjTitle">{{ruleForm.scwjmc}}</div>
        </div>
        <el-descriptions :column='2'>
          <el-descriptions-item label="类型：" width="80px" span="2">
            <span v-if="ruleForm.wjlx===1">文件夹</span>
            <span v-if="ruleForm.wjlx===2">文件</span>
          </el-descriptions-item>
          <el-descriptions-item label="位置：" span="2">
            <span v-if="ruleForm.wplx===0">学校网盘</span>
            <span v-if="ruleForm.wplx===1">个人网盘</span>
            <span v-if="ruleForm.wplx===2">部门网盘</span>
          </el-descriptions-item>
          <el-descriptions-item label="大小：" span="2">{{ruleForm.wjdx || 0}}M</el-descriptions-item>
          <el-descriptions-item label="时间：" span="2">{{ruleForm.wjscsj}}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDeatil: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDeatil', 'ReturnData'])

const ruleForm = ref({})

watch(
  () => props.openDeatil,
  () => {
    if (props.openDeatil) {
      loadData({
        url:
          '/api/v2/bangong/wangpanguanli/wangpanwenjianguanli/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
.detailBox {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
  height: 100%;
  .detailBox-top {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px dashed #e1eaf1;
    margin-bottom: 15px;
  }
  .wjIconBox {
    width: 40px;
    height: 40px;
    padding: 3px;
    border: 1px solid #eee;
    border-radius: 3px;
    margin-right: 15px;
  }
  .wjTitle{
    overflow-wrap: break-word;
    width: calc(100% - 60px);
  }
}
</style>
